import { gql, useQuery } from '@apollo/client'

export const LIST_TEMPLATES = gql`
  query ListTemplates($filters: TemplateQueryFilters, $limit: Int) {
    contentTemplateList(filters: $filters, limit: $limit) {
      templates {
        id
        name
        channel
        description
        subjectTemplate
        bodyTemplate
        createdAt
        updatedAt
      }
      pageInfo {
        endCursor
      }
    }
  }
`

export const GET_TEMPLATE = gql`
  query GetTemplate($id: ID!) {
    contentTemplate(id: $id) {
      id
      name
      channel
      description
      subjectTemplate
      bodyTemplate
      createdAt
      updatedAt
    }
  }
`

export const GET_TEMPLATE_USAGE = gql`
  query GetTemplateUsage($id: ID!) {
    contentTemplate(id: $id) {
      id
      name
      usageCount
      campaigns {
        id
        name
        active
      }
    }
  }
`

export const useTemplateList = (options = {}) => {
  return useQuery(LIST_TEMPLATES, {
    variables: { limit: 100 },
    fetchPolicy: 'cache-and-network',
    ...options,
  })
}
